import { connect } from 'react-redux';

import {
  confirmPayment,
  paymentFailed,
  submitCres,
  submitPares,
} from 'src/store/payment/actions';

import { finishPayment } from 'src/store/payment/slice';
import { selectCurrentPopup } from 'src/store/popup/selectors';
import { resetPopupState } from 'src/store/popup/slice';
import { getIsMobile } from 'src/store/view/selectors';
import { select3dsData } from '../../store/payment/selectors';
import { PaymentHidden3dsPopup } from './PaymentHidden3dsPopup';

const mapStateToProps = (state) => ({
  isOpened: selectCurrentPopup(state) === '3ds2.0',
  data: select3dsData(state),
  isMobile: getIsMobile(state),
});
const mapDispatchToProps = {
  submitCres,
  submitPares,
  confirmPayment,
  finishPayment,
  onFail: paymentFailed,
  closePopup: resetPopupState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentHidden3dsPopup);
